module.exports = __webpack_public_path__ + "img/icon_employees_tr.8a1b6960.png";